// 🔹 Stylesheets
import './EmailVerified.scss';

// 🔹 React Core
import React from 'react';

// 🔹 Routing
import { useNavigate } from 'react-router-dom';

// 🔹 Components
import { Button } from '../../components/Button/Button';
import { ReactComponent as PasswordVerifyIcon } from '../../../../assets/images/onboarding-trainer/password-verify.svg';
import { ReactComponent as BackIcon } from '../../../../assets/images/onboarding-trainer/back.svg';
import { ReactComponent as LogoIcon } from '../../../../assets/images/onboarding-trainer/logo.svg';

// 🔹 Assets

export const EmailVerified = () => {
  const navigate = useNavigate();

  return (
    <div className="onboarding-email-verified-container">
      <div className="email-verified-box">
        <div className="logo-placeholder">{<LogoIcon />}</div>
        <div className="success-icon-wrapper">{<PasswordVerifyIcon />}</div>
        <h1 className="email-verified-title">{'Your email has been verified'}</h1>
        <p className="email-verified-subtitle">{'You can now sign in with your new account'}</p>
        <Button
          variant="outline"
          className="submit-btn m-auto back-to-login"
          onClick={() => navigate('/onboarding-trainer/login')}
        >
          {<BackIcon />} Back to Log in
        </Button>
      </div>
      <div className="email-verified-bg-glow"></div>
    </div>
  );
};
